<section class="page-container">

    <header>
        <app-header [data]="data.HEADER" [pagina]="pagina"></app-header>
    </header>

    <main class="pt-5">
        <app-inicio *ngIf="pagina == 1" [data]="data.MAIN.INICIO" (validacao)="recebeValidacao($event)"
            (enviaImagem)="recebeImagemSelecionada($event)">
        </app-inicio>
        <app-envio *ngIf="pagina == 2" [data]="data.MAIN.ENVIO" (validacao)="recebeValidacao($event)"
            (enviaDados)="recebeDados($event)">
        </app-envio>
        <app-final *ngIf="pagina == 3" [data]="data.MAIN.FINAL">
        </app-final>
    </main>

    <footer>
        <app-footer [data]="data.FOOTER" [pagina]="pagina" [isValid]="isValid" (voltarNavegacao)="voltarNavegacao()"
            (avancarNavegacao)="avancarNavegacao()"></app-footer>
    </footer>

</section>